import React from "react";

import icon1 from "../assets/Images/icons8-easy-access.png";
import icon2 from "../assets/Images/icons8-money.png";
import icon3 from "../assets/Images/icons8-speed.png";

const IconsWraapper = () => {
  return (
    <div
      className="flex flex-col justify-evenly md:justify-start
       h-full items-center md:flex-row max-w-max pr-2
       
       
       "
    >
      <div className="pr-4  md:pr-[70px] flex flex-row w-full 
          items-center gap-5  md:flex-col justify-center md:items-end">
        <img src={icon2} alt="save monney" className="h-[38px] w-[38px]" />

        <span className="text-[18px] font-bold text-center">Free</span>
      </div>
      <div
        // border-t-2 md:border-r-2  md:border-t-0
        // border-b-2 md:border-l-2 border-[#000] md:border-b-0
        // h-24 md:h-auto
        className="pr-6 md:px-[70px] 
        
        flex flex-row w-full  relative
          items-center gap-6  md:flex-col justify-center md:items-center 
          before:border-l-0 before:absolute before:block before:bottom-0 before:left-0 before:w-2 before:h-[60px] md:before:border-l-2 before:border-[#000] 
          before:border-r-0 after:absolute after:block after:bottom-0 after:right-0 after:w-2 after:h-[60px] md:after:border-r-2 after:border-[#000] 
          border-t-2 md:border-t-0 
          border-b-2 md:border-b-0
          h-[134px] md:h-auto
              "
      >
        <img src={icon3} alt="speed" className="h-[38px] w-[38px]" />

        <span className="text-[18px] font-bold text-center">Fast</span>
      </div>
      <div
        className="pr-5  md:pl-[70px] md:pr-0 flex flex-row 
          items-center gap-4  md:flex-col justify-center md:items-end "
      >
        <img src={icon1} alt="easy access" className="h-[38px] w-[38px]" />

        <span className="text-[18px] font-bold text-center">Easy</span>
      </div>
    </div>
  );
};

export default IconsWraapper;
